import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ILoginRequest, ILoginResponseApi, IPasswordRequest, IRefreshTokenResponseApi } from '../interfaces/auth/auth.interface';
import { AccessService } from './users/access.service';
import { AlertService } from './alert.service';
import { IUserDetailResponseApi } from '../interfaces/users/user.interface';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);
  private readonly accessService = inject(AccessService);
  private readonly alertService = inject(AlertService);

  login(body: ILoginRequest) {
    localStorage.clear();
    sessionStorage.clear();

    return this.http.post<ILoginResponseApi>(
      `${environment.api}/auth/login`, body
    );
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();

    this.router.navigateByUrl('/', { skipLocationChange: true }).then();
  }

  createPassword(body: IPasswordRequest) {
    return this.http.put<ILoginResponseApi>(
      `${environment.api}/auth/create-password`, body
    );
  }

  forgotPassword(body: IPasswordRequest) {
    return this.http.put<ILoginResponseApi>(
      `${environment.api}/auth/forgot-password`, body
    );
  }

  loginMicrosoft(): void {
    window.location.href = `${environment.api}/auth/microsoft`;
  }

  setStorage(response: ILoginResponseApi) {
    sessionStorage.setItem('token', response.data.accessToken);
    sessionStorage.setItem('refreshToken', response.data.refreshToken);
    sessionStorage.setItem('role', response.data.user.role);
    sessionStorage.setItem('name', response.data.user.name);
    sessionStorage.setItem('accessProfile', response.data.user.accessProfileId);
    sessionStorage.setItem('personId', response.data.user.relatedPerson.id);

    this.setAccessProfile();
  }

  setStorageMicrosoft(
    accessToken: string,
    refreshToken: string,
    response: IUserDetailResponseApi
  ) {
    sessionStorage.setItem('token', accessToken);
    sessionStorage.setItem('refreshToken', refreshToken);
    sessionStorage.setItem('role', response.data.role);
    sessionStorage.setItem('name', response.data.name);
    sessionStorage.setItem('accessProfile', String(response.data.accessProfileId));
    sessionStorage.setItem('personId', response.data.relatedPerson.id);

    this.setAccessProfile();
  }

  setAccessProfile() {
    const accessId = sessionStorage.getItem('accessProfile') ?? '';
    this.accessService.getById(accessId).subscribe({
      next: (res) => {
        const accessPermissions = JSON.stringify(res.data.permissions);
        sessionStorage.setItem('accessPermissions', accessPermissions);
        this.router.navigate([this.getRedirect()]);
      },
      error: () => {
        this.alertService.show({
          type: 'error',
          subtitle: 'LOGIN.ACCESS_ERROR'
        });
      }
    })
  }

  getRedirect(): string {
    const role = sessionStorage.getItem('role') ?? '';

    if (role === 'Master') {
      return '/panel-master/home';
    }
    else {
      return '/panel/home';
    }
  }

  refreshToken(refreshToken: string) {
    return this.http.post<IRefreshTokenResponseApi>(
      `${environment.api}/auth/refresh`, {
        refreshToken,
        headers: new HttpHeaders().set('x-skip-loading', 'true')
      }
    );
  }
}
